var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M15.558 11.47 10.058 6 9 7.063l4.965 4.938L9 16.939l1.058 1.063 5.5-5.47a.75.75 0 0 0 0-1.063","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }